<template>
  <v-container>
    <div v-if="!$route.params.id">
      <div class="mb-6 title-icon">
      <h1 class>{{ $t('labels.apprentice-books')}}</h1>
      <v-btn icon :href="links.ebook.instructorInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
        </v-btn>
      </div>
      <MessageBox v-for="(o, index) in orderWarnings" :key="'order_'+ index" class="mb-7 mt-n6" type="alert" :closable="false">
        <h6>{{ $t("order.info.mb-warning-title2") }}</h6>
        <p v-html="$t('order.info.mb-warning-text2', {name: o.name})"></p>
        <p>{{$tc("order.info.days-left")}} <b> {{$tc("order.info.days-left-count", o.daysLeft)}}</b></p>
      </MessageBox>    
      <template>
        <MessageBox v-for="(b, index) in inactivedBooks" class="my-5" type="alert" :key="index">
          <h6>{{ $t("ebook.start-mb-title2") }}</h6>
          <p v-if="b.bookStatus.id==3 && b.daysUntilOrderApproval<0" v-html="$t('ebook.start-mb-text2', {fullname: b.fullname})"></p>
          <p v-else v-html="$t('ebook.start-mb-text4', {fullname: b.fullname})"></p>
        </MessageBox> 
      </template>     
      <!-- <h4>{{ isInstructor(0) ? $t("labels.my-apprentice") : $t("labels.apprentices") }}</h4> -->
      <!-- <template v-if="isInstructor(0) && isApprentice">
        <h2>{{ $t("labels.my-apprentice") }}</h2>
        <p class="mb-6">{{ $t("labels.my-apprentice-text") }}</p>
      </template> -->
      <ButtonArray text="left" :options="companyOptions" />
    </div>

    <div class="mt-0" v-if="$route.params.id && isCompanyUser(0) && isApprentice">
      <div v-for="(ebook, index) in currentUser.books" :key="index">
        <h2 class="mt-11" v-if="currentUser && currentUser.books && currentUser.books.length >= 2">{{$t('labels.my-apprenticenship')}} {{$t('labels.for')}} {{getProfessionNameById(ebook.professionId)}}</h2>
        <h1 class="mb-11" v-if="currentUser && currentUser.books && currentUser.books.length === 1">{{$t('labels.my-apprenticenship')}}</h1>
        <p class="mb-6" v-if="index==0">{{$t('labels.my-apprenticenship-text')}}</p>
        
        <template v-if="bookActive==false && ebook.bookStatus && ebook.bookStatus.id">
          <MessageBox class="my-5" type="info" v-if="ebook.bookStatus.id=='4'">
            <h6>{{ $t("ebook.pause-title") }}</h6>
            <p v-html="$t('ebook.pause-text', {startdate: getDate(getEducation(ebook).startDate)})"></p>
          </MessageBox>
           <MessageBox class="my-5" type="info" v-else-if="isAfterStartDate(ebook)==false">
            <h6>{{ $t("ebook.start-mb-title") }}</h6>
            <p v-html="$t('ebook.start-mb-text', {startdate: getDate(getEducation(ebook).startDate)})"></p>
          </MessageBox>
          <!-- <MessageBox class="my-5" type="info" v-else-if="selectedBook.bookStatus.id=='1'">
            <h6>{{ $t("ebook.inactive-title2") }}</h6>
            <p v-html="$t('ebook.inactive-text2', {startdate: getDate(getEducation(ebook).startDate)})"></p>
          </MessageBox> -->
          <MessageBox class="my-5" type="info" v-else-if="ebook.bookStatus.id=='5'">
            <h6>{{ $t("ebook.inactive-title3") }}</h6>
            <p v-html="$t('ebook.inactive-text3', {startdate: getDate(getEducation(ebook).startDate)})"></p>
          </MessageBox>
          <MessageBox class="my-5" type="info" v-else-if="ebook.bookStatus.id == '3'">
            <h6>{{ $t("ebook.inactive-title") }}</h6>
            <p v-html="$t('ebook.inactive-text', {startdate: getDate(getEducation(ebook).startDate)})"></p>
          </MessageBox>
        </template>

        <ButtonArray type="application" text="left" :options="getOptions(ebook)" />

      </div>
    </div>
  </v-container>
</template>

<script>
import ButtonArray from '@/components/Common/ButtonArray'
import {mapGetters, mapActions} from 'vuex'
import MessageBox from "@/components/Common/MessageBox";
import API from '@/services/api.js'
import uniq from "lodash/uniq"
import { uniqueId } from 'lodash';
import get from 'lodash/get'

const SugarDate = require('sugar/date')
// @group Ebook
// Styled EbookStart component
export default {
  name: 'EbookStart',
  components: {
    ButtonArray,
    MessageBox
  },

  data: () => ({
    links: require('../../../lib/external-links.json'),
    bookActive: false,
    daysLeft: 0,
    orderWarningDaysLeft: 0,
    orderWarnings: [],
    showWarningEbook: true,
    inactivedBooks: []
  }),
  created(){
    this.init()
  },
  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isCompanyUser', 'isApprentice', 'isInstructor', 'isAdminUser']),
    ...mapGetters('basic', ['getProfessionNameById']),
    
    companyOptions() {
      return [
        {
          user: 'isCompanyUser',
          route: {name: 'InstructorApprenticesReports', params: {id: this.currentUser.id}},
          actionIcon: '$sl-checklist-flip',
          title: this.$t('ebook.instructor.start.btn1'),
        },
        {
          user: 'isCompanyUser',
          route: {name: 'InstructorApprenticesCourses', params: {id: this.currentUser.id}},
          actionIcon: '$sl-owl',
          title: this.$t('ebook.instructor.start.btn2'),
        },
      ];
    },
  },
  methods: {
    init(){ //console.log("curr::", this.currentUser)
      this.getApprenticesList()      
    },
    isAfterStartDate(book){
      let education = this.currentUser.educations.find(e => e.id==book.educationId)      

      if(education && (SugarDate.Date.is(new Date(), education.startDate) || SugarDate.Date.isAfter(new Date(), education.startDate)))
          return true
      else
        return false
    },
    getEducation(book){
      let education = this.currentUser.educations.find(e => e.id==book.educationId)      
      return education
    },
    getDate(d){
      return SugarDate.Date(d).format('%Y-%m-%d')
    },
    getApprenticesList() {      
      let booksArray= []
      
      API.listBooks()
        .then(response => { 
          response.data.forEach(obj => {            
            if(obj.bookStatus && obj.bookStatus.id && (obj.bookStatus.id==1 || obj.bookStatus.id==3 || obj.bookStatus.id==4))
            {
              let name=''
              let daysUntilOrderApproval=0
              if(obj.person && obj.person.firstName)
                name=obj.person.firstName + ' '
 
               if(obj.person && obj.person.lastName)
                name += obj.person.lastName
              if(obj.education && obj.education.distanceOrder && obj.education.distanceOrder.latestApprovalDate){  
                daysUntilOrderApproval=Number(SugarDate.Date(obj.education.distanceOrder.latestApprovalDate).addDays(1).daysFromNow())
              }

               booksArray.push({fullname: name, id: obj.personId, bookStatus: obj.bookStatus, bookId: obj.id, daysUntilOrderApproval: daysUntilOrderApproval})                            
            }            
            if(obj.education && obj.education.distanceOrder && obj.education.distanceOrder.latestApprovalDate && obj.profession && obj.profession.daysUntilOrderApproval)
            { 
              if(obj.profession.daysUntilOrderApproval>0  && (SugarDate.Date(obj.education.distanceOrder.latestApprovalDate).daysFromNow() < (Number(obj.profession.daysUntilOrderApproval)/2)))
              {  
                let name=this.$t('labels.theApprentice')
                if(obj.person && obj.person.firstName)
                  name=obj.person.firstName + ' '
                if(obj.person && obj.person.lastName)
                  name+=obj.person.lastName
                
                let daysFromNow=Number(SugarDate.Date(obj.education.distanceOrder.latestApprovalDate).addDays(1).daysFromNow())
                if(daysFromNow<0)
                  daysFromNow=0
                if(obj.education.distanceOrder && obj.education.distanceOrder.stateId === 1) { 
                  this.orderWarnings.push({
                    name: name,
                    daysLeft: daysFromNow
                  })
                }
              }
            }
          })

          this.inactivedBooks = booksArray//uniq(booksArray, 'id')
          //console.log("booksArray::", booksArray)
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })        
    },
    getOptions(ebook) {
      return [
        {
          user: 'isCompanyUser',
          route: {name: 'EbookReportElement', params: {id: ebook.id}},
          actionIcon: '$sl-ebook-add',
          title: this.$t('ebook.instructor.company-user-reports'),
        },
        {
          user: 'isCompanyUser',
          route: {name: 'EbookReportOverviewStart', params: {id: ebook.id}},
          actionIcon: '$sl-checklist-flip',
          title: this.$t('ebook.instructor.company-user-my-reports'),
        },
        {
          user: 'isCompanyUser',
          route: {name: 'EbookEducationStart', params: {id: ebook.id}},
          actionIcon: '$sl-owl',
          title: this.$t('ebook.instructor.company-user-my-education'),
        },
      ];
    },
  },
}
</script>

<style scoped>
